import * as React from "react";
import "./legal-pages.scss";

interface ILegalPagesProps {
  readonly children: any;
}

class LegalPages extends React.Component<ILegalPagesProps, {}> {
  public render() {
    return (
      <div className="legal-pages">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-lg-10 offset-lg-1">
              {this.props.children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LegalPages;



// WEBPACK FOOTER //
// ./src/components/legal-pages/legal-pages.tsx